import { Component, OnInit } from '@angular/core';
import { NeproseService } from 'src/app/services/neprose.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-my-properties',
  templateUrl: './my-properties.component.html',
  styleUrls: ['./my-properties.component.css']
})
export class MyPropertiesComponent implements OnInit {

  dataLoaded: boolean

  propertyList = []

  municipalityList = []

  constructor( private _neproseService: NeproseService, private route: ActivatedRoute, private _router: Router, private _notification: MatSnackBar ) { }

  ngOnInit(): void {
    this.route.data.subscribe((data: { municipalityList: any})=> {
      this.municipalityList = data.municipalityList.municipalities
    })
    this.getPropertyList()
  }

  getPropertyList(){
    this._neproseService.getMyProperties().subscribe(data => {
      this.dataLoaded = true
      if(data.propertyAd){
        let propertyList = data.propertyAd
        for(let property of propertyList){
          if(property.status == 'pending' || property.status == 'requested'){
            property['featuredImage'] = null
            if(property.PropertyImage){
              let propertyImages = JSON.parse(property.PropertyImage.imagePath)
              if(propertyImages.length > 0){
                property.featuredImage = environment.api+'/images/'+propertyImages[0]
              }
            }
            let municipality = this.municipalityList.find(municipality => municipality.id == property.municipality_id)
            let address = municipality.municipality
            if(property.village){
              address = property.village+', '+address
            }
            property['address'] = address
            this.propertyList.push(property)
          }
        }
      }
    })
  }

  paymentForProperty(id){
    this._router.navigate(['/property/'+id+'/payment'])
  }


  viewProperty(id){
    this._router.navigate(['/edit-property/'+id])
  }

  editProperty(id){
    this._router.navigate(['/edit-property/'+id])
  }

}
